export default "__VITE_ASSET__DhAC_oWt__"